import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ServiceLogin } from '../app/servicio/ServiceLogin';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { Keepalive } from '@ng-idle/keepalive';
import { HttpClient } from '@angular/common/http';
import * as signalR from "@microsoft/signalr";

@Component({
  // tslint:disable-next-line
  selector: 'body',
  templateUrl: 'app.component.html'
})
export class AppComponent implements OnInit {

    //Mensaje
    public data: any[];
    private hubConnection: signalR.HubConnection;

    

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  title = 'angular-idle-timeout';
  public modalRef: BsModalRef;

  @ViewChild('childModal', { static: false }) childModal: ModalDirective;
  constructor(private http: HttpClient,@Inject(LOCAL_STORAGE) private storage: WebStorageService,private idle: Idle, private keepalive: Keepalive, private router: Router, private modalService: BsModalService, private servicio: ServiceLogin) {
    idle.setIdle(300);
    idle.setTimeout(5);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.'
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      this.childModal.hide();
      this.idleState = 'Timed out!';
      this.timedOut = true;
      this.storage.remove("USUARIO");
      this.storage.remove("AUTORIZA");
      this.storage.remove("TOKEN");
      this.storage.remove("AD");
      this.storage.remove("EMPRESA");
      this.storage.remove("USRID");
      this.router.navigate(['/']);
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!'
      this.childModal.show();
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'Tiempo de espera en ' + countdown + ' segundos!'
    });

    // sets the ping interval to 15 seconds
    keepalive.interval(900);

    keepalive.onPing.subscribe(() => this.lastPing = new Date());

    this.servicio.getUsuarioLoginIn().subscribe(userLoggedIn => {
      if (userLoggedIn) {
        idle.watch()
        this.timedOut = false;
      } else {
        idle.stop();
      }
    });
  }

  reset() {
    this.idle.watch();
    //xthis.idleState = 'Started.';
    this.timedOut = false;
  }

  hideChildModal(): void {
    this.childModal.hide();
  }

  stay() {
    this.childModal.hide();
    this.reset();
  }
  logout() {
    this.childModal.hide();
    this.servicio.setUsuarioLoginIn(false);

    this.storage.remove("USUARIO");
    this.storage.remove("AUTORIZA");
    this.storage.remove("TOKEN");
    this.storage.remove("AD");
    this.storage.remove("EMPRESA");
    this.storage.remove("USRID");

    this.router.navigate(['/']);
  }
  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}
